import React from 'react';

const ScooterGanIcon = () => {
  return (
    <svg width="50" height="50" viewBox="0 0 79.61 79.61">
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="5.34"
          y1="19.91"
          x2="74.27"
          y2="59.7"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#024284" />
          <stop offset="0.81" stop-color="#004587" />
          <stop offset="0.82" stop-color="#68a93e" />
        </linearGradient>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
          <circle
            cx="39.8"
            cy="39.8"
            r="38.56"
            style={{
              fill: 'none',
              strokeMiterlimit: '10',
              strokeWidth: '2.48162492794007px',
              stroke: 'url(#linear-gradient)',
            }}
          />
          <circle
            cx="25.09"
            cy="47.82"
            r="3.99"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeMiterlimit: '10',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <circle
            cx="54.52"
            cy="47.82"
            r="3.99"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeMiterlimit: '10',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <line
            x1="31.41"
            y1="47.65"
            x2="48.12"
            y2="47.65"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeMiterlimit: '10',
              strokeWidth: '2.28858660421371px',
            }}
          />
          <polyline
            points="54.1 41.09 52.1 23.8 46.37 23.8"
            style={{
              fill: 'none',
              stroke: '#024284',
              strokeLinecap: 'round',
              strokeMiterlimit: '10',
              strokeWidth: '2.28858660421371px',
            }}
          />
        </g>
      </g>
    </svg>
  );
};

export default ScooterGanIcon;
